import { NgModule, forwardRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InlineSVGModule } from "ng-inline-svg-2";
import { RouterModule, Routes } from "@angular/router";
import {
  NgbDropdownModule,
  NgbProgressbarModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { TranslationModule } from "../../i18n";
import { LayoutComponent } from "./layout.component";
import { ExtrasModule } from "../partials/layout/extras/extras.module";
import { HeaderComponent } from "./components/header/header.component";
import { ContentComponent } from "./components/content/content.component";
import { FooterComponent } from "./components/footer/footer.component";
import { CustomerSlotsComponent } from "src/shared/customer-slots/customer-slots.component";
import { ScriptsInitComponent } from "./components/scripts-init/scripts-init.component";
import { ToolbarComponent } from "./components/toolbar/toolbar.component";
import { TopbarComponent } from "./components/topbar/topbar.component";
import { PageTitleComponent } from "./components/header/page-title/page-title.component";
import { HeaderMenuComponent } from "./components/header/header-menu/header-menu.component";
import { DrawersModule, DropdownMenusModule, ModalsModule } from "../partials";
import { ThemeModeModule } from "../partials/layout/theme-mode-switcher/theme-mode.module";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { SidebarLogoComponent } from "./components/sidebar/sidebar-logo/sidebar-logo.component";
import { SidebarMenuComponent } from "./components/sidebar/sidebar-menu/sidebar-menu.component";
import { SidebarFooterComponent } from "./components/sidebar/sidebar-footer/sidebar-footer.component";
import { NavbarComponent } from "./components/header/navbar/navbar.component";
import { AccountingComponent } from "./components/toolbar/accounting/accounting.component";
import { ClassicComponent } from "./components/toolbar/classic/classic.component";
import { ExtendedComponent } from "./components/toolbar/extended/extended.component";
import { ReportsComponent } from "./components/toolbar/reports/reports.component";
import { SaasComponent } from "./components/toolbar/saas/saas.component";
import { SharedModule } from "../../../shared/shared.module";
import { SideMenuItemComponent } from "./components/sidebar/sidebar-menu/menu-item/menu-item.component";
import { SideMenuAccordionComponent } from "./components/sidebar/sidebar-menu/menu-accordion/menu-accordion.component";
import { SideMenuSectionComponent } from "./components/sidebar/sidebar-menu/menu-section/menu-section.component";
import { HeaderMenuItemComponent } from "./components/header/header-menu/menu-item/menu-item.component";
import { HeaderMenuAccordionComponent } from "./components/header/header-menu/menu-accordion/menu-accordion.component";
import { HeaderMenuSectionComponent } from "./components/header/header-menu/menu-section/menu-section.component";
import { LangSwitcherModule } from "../partials/layout/lang-switcher/lang-switcher.module";
import { Routing } from "src/app/pages/routing";
import { NgxPermissionsModule } from "ngx-permissions";
import { BrandLogoComponent } from "src/shared/brand-logo/brand-logo.component";

const routing: Routes = [
  {
    path: "",
    component: LayoutComponent,
    children: Routing,
  },
];

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderComponent,
    ContentComponent,
    FooterComponent,
    ScriptsInitComponent,
    ToolbarComponent,
    TopbarComponent,
    PageTitleComponent,
    HeaderMenuComponent,
    SidebarComponent,
    SidebarLogoComponent,
    SidebarMenuComponent,
    SidebarFooterComponent,
    NavbarComponent,
    AccountingComponent,
    ClassicComponent,
    ExtendedComponent,
    ReportsComponent,
    SaasComponent,
    SideMenuItemComponent,
    SideMenuAccordionComponent,
    SideMenuSectionComponent,
    HeaderMenuItemComponent,
    HeaderMenuAccordionComponent,
    HeaderMenuSectionComponent,
  ],
  imports: [
    BrandLogoComponent,
    CustomerSlotsComponent,
    CommonModule,
    RouterModule.forChild(routing),
    TranslationModule,
    InlineSVGModule,
    NgbDropdownModule,
    NgbProgressbarModule,
    ExtrasModule,
    ModalsModule,
    DrawersModule,
    DropdownMenusModule,
    NgbTooltipModule,
    TranslateModule,
    ThemeModeModule,
    forwardRef(() => SharedModule),
    LangSwitcherModule,
  ],
  exports: [RouterModule],
})
export class LayoutModule {}
